<template>
  <div>
      <el-container class="SelectBlock">


        <el-col class="FirstBlock" :sapn="3" >
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              选择查询的需要<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">根据资产名称查询</el-dropdown-item>
              <!-- <el-dropdown-item command="c">根据资产固定编码查询</el-dropdown-item> -->
              <!-- <el-dropdown-item command="d">根据类别查询</el-dropdown-item> -->
              <el-dropdown-item command="e">根据存放的区域查询</el-dropdown-item>
              <el-dropdown-item command="g">根据资产状态查询</el-dropdown-item>
              <!-- <el-dropdown-item command="h">根据是否为帐外资产查询</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>


            <el-input v-if="selectCheck == 'a'" v-model.trim ="SForm.SpropertyName" placeholder="根据资产名称查询"></el-input>

            <el-input v-if="selectCheck == 'b'" v-model.trim ="SForm.SownerId" :value="ManagerUser"  placeholder="根据使用人姓名ID查询">
                <el-button
                  size="mini"
                   style="padding-right:10px"
                   slot="suffix"
                   type="text"
                  @click="dialogManager = true">选择</el-button> </el-input>
                  <el-dialog title="选择资产类别" :visible.sync="dialogManager" width="35%">
                    <el-tree
                      class ="TreeBlock"
                      :data="MangerData"
                      :filter-node-method="filterNode"
                      node-key="id"
                      @node-click="TreeMangerClick"
                      ref="tree"
                      :props="defaultProps"
                      default-expand-all:false
                      :expand-on-click-node="false">
                      <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>{{ node.label }}</span>
                      </span>
                    </el-tree>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="dialogManager = false">取 消</el-button>
                      <el-button type="primary" @click="dialogManager = false;">确 定</el-button>
                    </div>
                  </el-dialog>


            <el-input v-if="selectCheck == 'c'" v-model.trim ="SForm.SpropertyCode" placeholder="根据资产固定编码查询"></el-input>

            <el-input v-if="selectCheck == 'e'" v-model.trim ="SForm.SplaceId" :value="SForm.SplaceRealId"
            append-to-body
            style="width: 250px;"
            placeholder="根据存放的区域查询">
                <el-button
                  size="mini"
                   style="margin-top: 5px;"
                   slot="suffix"
                   type="text"
                  @click="dialogPlace = true">选择</el-button></el-input>
                  <el-dialog title="选择资产存放区域" :visible.sync="dialogPlace" width="35%">
                    <el-tree
                      class ="TreeBlock"
                      :data="PlaceData"
                      :filter-node-method="filterNode"
                      node-key="id"
                      @node-click="TreePlaceClick"
                      ref="tree"
                      :props="defaultProps"
                      default-expand-all:false
                      :expand-on-click-node="false">
                      <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>{{ node.label }}</span>

                      </span>
                    </el-tree>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="dialogPlace = false">取 消</el-button>
                      <el-button type="primary" @click="dialogPlace = false;">确 定</el-button>
                    </div>
                  </el-dialog>


            <el-input v-if="selectCheck == 'd'"  v-model.trim ="SForm.SpropertyTypeId" placeholder="根据类别查询"></el-input>


            <el-select v-if="selectCheck == 'f'" v-model.trim ="SForm.SunitId" placeholder="根据单位查询">
             <el-option
             v-for="i in DUnit"
             :label="i.unitName"
             :key="i.unitId"
             :value="i.unitId">
             </el-option>

             <el-select v-if="selectCheck == 'h'" v-model.trim ="SForm.SoutProperty" placeholder="根据是否为帐外资产查询">
               <el-option label="是" value="1"></el-option>
               <el-option label="否" value="2"></el-option>
             </el-select>
            </el-select>


            <el-select v-if="selectCheck == 'g'" v-model.trim ="SForm.SpropertyState" placeholder="是否为资产状态">
              <el-option label="已盘" value='1'></el-option>
              <el-option label="未盘" value='2'></el-option>
              <el-option label="盘亏" value='3'></el-option>
              <el-option label="盘盈" value='4'></el-option>
              <el-option label="损毁待报废" value='5'></el-option>
              <el-option label="闲置" value='6'></el-option>
              <el-option label="异常已盘" value='7'></el-option>
            </el-select>






          <el-button type="primary" @click="select(1)">查询</el-button>
          <el-button type="primary" @click="resetForm('SForm')">重置</el-button>
        </el-col>
      </el-container>


      <el-table
         :data="tableData"
         style="width: 100%">
         <el-table-column
           label="盘点详情的ID"
           prop="checkDetailId">
         </el-table-column>

         <el-table-column
           label="盘点资产名称"
           prop="propertyName">
         </el-table-column>


         <el-table-column
           label="资产的RFID "
           prop="propertyRfid">
         </el-table-column>

         <el-table-column
           label="资产房间号"
           prop="propertyPlace">
         </el-table-column>
         <el-table-column
           label="资产的房间上级"
           prop="placeMgr">
         </el-table-column>



         <el-table-column
           label="资产名称"
           prop="propertyName">
         </el-table-column>
         <el-table-column
           label="盘点状态"
           prop="checkState"
           >
           <template slot-scope="scope">
             <el-tag
             :type="scope.row.checkState == 1?''
             :(scope.row.checkState==2?'success'
             :(scope.row.checkState==3?'info'
             :(scope.row.checkState==4?'info'
             :(scope.row.checkState==5?'info'
             :(scope.row.checkState==6?'info'
             :(scope.row.checkState==7?'danger':'warning'))))))"
             effect="dark">
               <div v-if="scope.row.checkState == 1">已盘</div>
               <div v-if="scope.row.checkState == 2">未盘</div>
               <div v-if="scope.row.checkState == 3">盘亏</div>
               <div v-if="scope.row.checkState == 4">盘盈</div>
               <div v-if="scope.row.checkState == 5">损毁待报废</div>
               <div v-if="scope.row.checkState == 6">闲置</div>
               <div v-if="scope.row.checkState == 7">异常已盘</div>

             </el-tag>
           </template>
         </el-table-column>

         <el-table-column
           label="资产房间号"
           prop="propertyPlace">
         </el-table-column>
       </el-table>

       <div class="block">
                <el-pagination
                  @size-change="select"
                  @current-change="currentChange"
                  :current-page.sync="currentPage"
                  :page-size="10"
                  layout="prev, pager, next, jumper"
                  :total="pageSize">
                </el-pagination>
              </div>

      </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'CheckMissionDeatilTable',
     data () {
      const PlaceData = [{
          id: 1,
          label: '一级 1',
          children: [{
            id: 4,
            label: '二级 1-1',
            children: [{
              id: 9,
              label: '三级 1-1-1'
            }, {
              id: 10,
              label: '三级 1-1-2'
            }]
          }]
        }];
       return {
        dialogManager:false,
        dialogPlace:false,
        PlaceData: JSON.parse(JSON.stringify(PlaceData)),
         selectCheck:'',
         checkId: '',
        currentPage: 1,
        pageSize:1,
        SForm:{
          SpropertyState:'',
          SPlace:'',
          SpropertyName:''
        },
        drawer: false,
        direction: 'rtl',
        defaultProps: {
        children: 'children',
        label: 'label'
      },
      MangerData:[{
              id:'',
              label: '',
              realId:'',
              operator:'',
              children: [{
                id:'',
                label: '',
                realId:'',
                operator:'',
                children: [{
                  id:'',
                  label: '',
                  realId:'',
                  operator:'',
                }]
              }]
            }],
         tableData:[{
          checkDetailId:'',
        			propertyRfid:'',
        			unitId:'',
        			checkType:'无',
        			checkState:'',
        			detailMsg:'',
        			belongCheckTaskId:'',
        			endDate:"暂未完成",
        			propertyName:'',
        			propertyPlace:'',
        			placeMgr:'',
         }]
        };
     },
     mounted:function() {
      this.checkId = this.$parent.$parent.$parent.$parent.checkId
      this.showMData();
      this.showData();
      this.showPlaceData();
     },
     methods: {
		//重置数据
       resetForm(formName) {
         Object.assign(this.$data.SForm, this.$options.data().SForm)
         this.select()
           },
    TreePlaceClick(data){
      this.SForm.SplaceRealId = data.id
      this.SForm.SplaceId = data.label
      this.searchData = data.label
    },
    showPlaceData(){
      var authorization = Cookies.get("Authorization");
      var params = {
        currentPage: 1,
        pageSize: 5,
        unitId: Cookies.get('unitId')
      }
        this.axios({
            method: 'GET',
            url: '/public/getPlaceTreeV2',

            header:{
            'Authorization':authorization,
            'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            }
          }).then((resp)=>{

          this.PlaceData=resp.data.data;
          })
      },
    TreeMangerClick(data){
          this.ManagerUser = data.realId
          this.searchData = data.label
      },
    filterNode(value, data) {
              if (!value) return true;
              return data.label.indexOf(value) !== -1;
            },
    showMData(){
      var authorization = Cookies.get("Authorization");
        this.axios({
            method: 'GET',
            url: '/public/getUnitTree',
            header:{
            'Authorization':authorization,
            'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            }
          }).then((resp)=>{

          var arr = new Array(resp.data.data) ;
          this.MangerData=resp.data.data;
          this.UserData = resp.data.data;
          })
      },
	  //侦测到点击的是哪一个子任务，之后通过子任务查询	   
      handleCommand(command) {
            var authorization = Cookies.get("Authorization");
            var paramsData = {
              checkId:this.$parent.$parent.$parent.$parent.checkId,
              checkTaskId:this.$parent.$parent.$parent.$parent.taskId,
              state: parseInt(command)
            }

            this.axios({
                method: 'POST',
                url: '/check/updateState',
                params:paramsData,
                header:{
                 'Authorization':authorization,
                	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                	}
              }).then((resp)=>{
                console.log(resp)
             })
            },
			// 下拉菜单存放点击时选中的数据
       handleCommand(command) {
              this.selectCheck = command
             },
	   // 根据条件查询数据
       select(){
        
         
          var authorization = Cookies.get("Authorization");
          var paramsData = {
            currentPage: this.currentPage,
            pageSize: 10,
            propertyName:this.SForm.SpropertyName,
            propertyPlaceId:this.SForm.SplaceRealId,
            
            checkState:this.SForm.SpropertyState || undefined,
            taskId:this.$parent.$parent.$parent.$parent.taskId || undefined,
			      checkId:this.$parent.$parent.$parent.$parent.checkId|| undefined,
            // taskId:taskId || undefined,
            // checkId:checkId || undefined,
          }
           this.axios({
               method: 'GET',
               url: '/check/getDetailByTaskDto',
               params:paramsData,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
                this.tableData=resp.data.data;
                this.pageSize = resp.data.count;
             })
       },
       currentChange(val) {
        this.currentPage = val
        this.select()
       },



	    // 查看盘点详情的所有数据（不分类）
        showData(){
          var authorization = Cookies.get("Authorization");
          var params = {
            checkId:this.$parent.$parent.$parent.$parent.checkId,
            currentPage: 1,
            pageSize: 10,
          }
           this.axios({
               method: 'GET',
               url: '/check/getDetailByTaskDto',
               params:params,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
              this.tableData = resp.data.data;
              this.pageSize = resp.data.count;
             })
            },
     }
   }
</script>

<style>
  .SelectBlock .el-input{
    width: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Check/CheckMissionDeatilTable.vue